"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSearchExp = exports["default"] = void 0;
var _AST = _interopRequireDefault(require("./AST"));
var _ASTCompiler = _interopRequireDefault(require("./ASTCompiler"));
var _Lexer = _interopRequireDefault(require("./Lexer"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SearchExp = exports["default"] = /*#__PURE__*/function () {
  function SearchExp(expr) {
    _classCallCheck(this, SearchExp);
    this.lexer = new _Lexer["default"]();
    this.ast = new _AST["default"](this.lexer);
    this.ASTCompiler = new _ASTCompiler["default"](this.ast);
    this._matcher = this.ASTCompiler.compile(expr);
  }
  return _createClass(SearchExp, [{
    key: "match",
    value: function match(text) {
      return this._matcher(text, function (text, query, position) {
        var index = text.indexOf(query);
        var newPosition = position;
        var contains = index !== -1;
        if (contains) {
          newPosition = index + query.length;
        }
        return [contains, newPosition];
      });
    }
  }]);
}();
var isSearchExp = exports.isSearchExp = function isSearchExp(query) {
  return [_constants.AND, _constants.NOT, _constants.OR].some(function (o) {
    return query.includes(o);
  });
};